import type { KeyboardEvent } from "react";

interface ToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** accessible label (required since the switch has no visible text) */
  label: string;
  disabled?: boolean;
  className?: string;
}

/** role=switch with Space/Enter keyboard activation (mirrors ui/assets/ui.js). */
export function Toggle({ checked, onChange, label, disabled, className }: ToggleProps) {
  function onKeyDown(e: KeyboardEvent<HTMLSpanElement>) {
    if (disabled) return;
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      onChange(!checked);
    }
  }
  return (
    <span
      role="switch"
      aria-checked={checked}
      aria-label={label}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      className={["switch", className].filter(Boolean).join(" ")}
      onClick={() => !disabled && onChange(!checked)}
      onKeyDown={onKeyDown}
    />
  );
}
